<template>
    <div class="feedback-wrapper" @click="globalclick">
        <div class="feedback" @click="show">
            <div class="icon icon-p-phone"></div>
        </div>
        <div class="feedback-dialog-wrapper" v-show="fd_show">            
            <div class="feedback-dialog">
                <i class="icon icon-close" @click="close"></i>
                <h2 class="fd-title">FeedBack</h2>
                <Dropdonw
                        title="Feedback Type"
                        :choices="feedType"
                        keys="selectIndex"    
                        :is_show="obj.feedbackTypeIsShow" 
                        :selectIndex=selectIndex
                        label="Feedback Type" 
                        @modify = "modify_dropdown"
                        @setValue="setValue"
                ></Dropdonw>
                <Upload
                    title="Feedback Image"
                    @modify = "modify_upload"
                ></Upload>
                <div class="form-element">
                    <textarea name="" id="" cols="30" rows="10" @input="tinput" v-model="obj.content" placeholder="Please fill in the questions and comments you encounter, we will try to do better"></textarea>
                    <div class="number-limit" v-text="`${obj.content.length} / 300`"></div>
                </div>                
                <div class="service">
                    Email: <span v-text="mail"></span> <br>
                    Phone: <span v-text="phone"></span>
                </div>
                <div class="btn-group">
                    <button type="button" class='fd-button' @click="submit">Submit</button>
                </div>
            </div>
        </div>        
    </div>        
</template>
<script>
import { feedback,feedbackConfig,getConfig } from "@api/index";
import Dropdonw from '@/components/business/kyc/dropdown_normal.vue'
import Upload from '@/components/business/kyc/upload_normal.vue'
export default { 
    components:{
        Dropdonw,
        Upload
    },
    data () {
        return {
            obj:{
                content:'',
                feedbackTypeIsShow:false,
                feedbackFile:null
            },   
            fd_show:false,
            clicked:false,
            feedType:[],
            selectIndex:-1,
            phone:"",
            mail:""
        }
    },
    mounted () {
        getConfig().then((res)=>{
            if(res.code == 0) {
                this.phone = res.data.customer.phone
                this.mail = res.data.customer.email
            }
        })

        feedbackConfig().then(res=>{
            this.feedType = res.data
        })
        
    },
    computed : {
        problemDesc () {            
            for(let i=0;i<this.feedType.length;i++) {
                if(i == this.selectIndex) {
                    return this.feedType[i]['problemDesc']
                }
            }
            return ""            
        },
        problemType () {            
            for(let i=0;i<this.feedType.length;i++) {
                if(i == this.selectIndex) {
                    return this.feedType[i]['problemType']
                }
            }             
            return -1            
        }
    },
    methods:{
        globalclick () {
            this.obj['feedbackTypeIsShow'] = false
        },
        setValue(v,key) {
            console.log(v)
            this[key] = v 
        },
        modify_dropdown (v)  {
            console.log(v)
            this.obj['feedbackTypeIsShow'] = v 
            
        },
        modify_upload(v) {
            this.obj['feedbackFile'] = v
        },
        submit () {
            if(this.clicked)return 
            this.clicked = true
            if(this.obj.content.length == 0)return
            let formData = new FormData()
            formData.append('content', this.obj.content)
            formData.append('multipartFiles', this.obj.feedbackFile)
            formData.append('problemDesc', this.problemDesc)
            formData.append('problemType', this.problemType)
            feedback(formData).then(resp => {
                if(resp.code == 0) {
                    this.close()                    
                }
                this.content = ""
                this.selectIndex = -1
                this.obj.feedbackFile = null
                this.clicked = false
            })
        },
        tinput () {
            let reg = /[^A-Za-z0-9_?!,. ]+/
            if(this.obj.content.length > 300) {
                this.obj.content = this.obj.content.substring(0, this.obj.content.length - 1)
            }
            if(reg.test(this.obj.content)) {
                this.obj.content = this.obj.content.substring(0, this.obj.content.length - 1)
            }
        },

        close () {
            this.obj.content = ""
            this.selectIndex = -1                        
            this.fd_show = false                            
        },
        show () {
            this.fd_show = true
        }
    }
}
</script>
<style lang="less" scoped>
@import "~assets/less/icon.less";
    .service{
        text-align: center;
        font-size: 32px;
        color:#999;
        line-height:1.5;
        margin-top: 20px;
    }
    .feedback-wrapper{
        .feedback{
            position: fixed;
            bottom:200px;
            right:0;
            width:100px;
            height: 70px;
            border-radius: 50px 0 0 50px;
            background:#dcf5dc;
            padding-top: 30px;
            z-index: 10;
        }
    }
    .feedback-dialog-wrapper{
        width: 100%;
        height: 100%;
        left:0;
        top:0;
        right:0;
        bottom:0;
        background:rgba(0,0,0,0.7);
        position: fixed;
        z-index: 99999;
        .icon{
            position:absolute;
            top:10px;
            right:10px;
        }
    }
    .feedback-dialog{
        position: absolute;
        width: 690px;
        height:100%;
        // height: 600px;
        background:#fff;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        padding:0 30px;
        // border-radius: 20px;
        .fd-title{
            text-align:center;
            font-size: 42px;
            font-weight: 700;
            color:#00CD98;
            margin: 50px 0;
        }
        .form-element{
            border:2px solid #00CD98;
            padding:20px 30px;
            height:200px;
            margin-top: 50px;
            .number-limit{
                height:30px;
                font-size: 24px;
                float:right;
                margin-top: 10px;
                color:#999;
            }
            textarea{
                border:none;
                font-size: 24px;
                width: 100%;
                height: 170px;
                display: block;
                resize:none;
                word-break: break-all;
                &:focus-visible{
                    outline: none;
                }
            }
        }
        .btn-group{
            width: 500px;
            margin:50px auto;
            .fd-button{
                display:block;
                width: 500px;
                height: 96px;
                background: #00CD98;
                border:none;
                border-radius: 12px;
                color: #FFFFFF;
                text-align: center;
                line-height: 96px;
                font-size: 32px;
                margin:0 auto;
            }
        }
        
    
    }
</style>